import { StyleSheet } from 'lib/paypalphrodite'

const largeGreenSpinner = {
  /* Identical composition to spinner-large from the vx lib */
  height: 128,
  opacity: '0.56',
  width: 128,
  animation: 'vx_spin 620ms infinite linear',
  backgroundImage:
    "url(\"data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 98 98' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M-1-1h98.967v99.174H-1z'/%3E%3Cpath d='M49 96.917C22.536 96.917 1.083 75.464 1.083 49 1.083 22.536 22.536 1.083 49 1.083c26.464 0 47.917 21.453 47.917 47.917' stroke='%23005EA6' stroke-width='2' stroke-linecap='square'/%3E%3C/g%3E%3C/svg%3E\")",
  content: '',
  display: 'block',
}

const mediumBlueSpinner = {
  /* Identical composition to spinner-large from the vx lib */
  height: 36,
  opacity: '1',
  width: 36,
  marginLeft: 30,
  animation: 'vx_spin 620ms infinite linear',
  backgroundImage:
    "url(\"data:image/svg+xml,%3Csvg width='36' height='36' viewBox='0 0 98 98' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M-1-1h98.967v99.174H-1z'/%3E%3Cpath d='M49 96.917C22.536 96.917 1.083 75.464 1.083 49 1.083 22.536 22.536 1.083 49 1.083c26.464 0 47.917 21.453 47.917 47.917' stroke='%23005EA6' stroke-width='2' stroke-linecap='square'/%3E%3C/g%3E%3C/svg%3E\")",
  content: '',
  display: 'block',
}

export default StyleSheet.create({
  'vx_spinner-large': {
    ':after': largeGreenSpinner,
    ...largeGreenSpinner,
  },
  'vx_spinner-medium': {
    ':after': mediumBlueSpinner,
    ...mediumBlueSpinner,
  },
  wrapper: {
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    zIndex: '2000', // must be 1051 or higher to rise above overpanel.js
  },
  background: {
    background: 'rgba(255, 255, 255, .92)',
    width: '100%',
    height: '100%',
    transition: 'all .25s ease',
  },
  pulse: {
    animationName: {
      '0%': {
        opacity: '0',
        transform: 'scale(1)',
      },
      '50%': {
        opacity: '1',
        transform: 'scale(1.05)',
      },
      '100%': {
        opacity: '0',
        transform: 'scale(1)',
      },
    },
    animationDuration: '2s',
    animationIterationCount: 'infinite',
  },
  // fadeIn and fadeOut exist because the animation can't be accomplished with transitions in this case.
  // The wrapper component itself is being flipped from display: none; at the same time as it's other property changes.
  // The wrapper and it's children must be in the flow to have initial property values to transition from.
  fadeIn: {
    animationName: {
      '0%': {
        opacity: '0',
        transform: 'scale(.9)',
      },
      '100%': {
        opacity: '1',
        transform: 'scale(1)',
      },
    },
    animationDuration: '.3s',
  },
  fadeOut: {
    animationName: {
      '0%': {
        opacity: '1',
        transform: 'scale(1)',
      },
      '100%': {
        opacity: '0',
        transform: 'scale(.9)',
      },
    },
    animationDuration: '.3s',
  },
  centeredContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-100px, -70px)',
    height: '140px',
    width: '200px',
    textAlign: 'center',
  },
  basicPosition: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    marginTop: '-70px',
    marginLeft: '-65px',
  },
})
